import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

function getCategoryByAlternativeCategoryId(
    alternativeProductCategories: CreditCardAlternativeProductsCategory[],
    categoryId: string
) {
    return alternativeProductCategories?.find(
        category => category.id === categoryId
    )
}

export default getCategoryByAlternativeCategoryId
